import { render, staticRenderFns } from "./Enamorate.vue?vue&type=template&id=5f97fbcd"
import script from "./Enamorate.vue?vue&type=script&lang=js"
export * from "./Enamorate.vue?vue&type=script&lang=js"
import style0 from "./Enamorate.vue?vue&type=style&index=0&id=5f97fbcd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports